import { useMutation, useQuery } from "react-query";
import {
	generateSGTINS,
	generateSSCC,
	getSGTINSData,
	getSSCCData,
	downloadSgtinLabels,
} from "../api-services/serialization";

const ssccKey = "sscc-data";
const sgtinKey = "sgtin-data";

const useGenerateSSCC = (mutationOptions = {}) => {
	const mutation = useMutation({
		mutationFn: (payload) => generateSSCC(payload),
		onSuccess: (data) => {
			if (mutationOptions.onSuccess) {
				mutationOptions.onSuccess(data);
			}
		},
		onError: (error) => {
			if (mutationOptions.onError) {
				mutationOptions.onError(error);
			}
		},
	});

	return {
		generateSSCC: mutation.mutate,
		isLoading: mutation.isPending,
		...mutation,
	};
};

const useGenerateSGTIN = (mutationOptions = {}) => {
	const mutation = useMutation({
		mutationFn: (payload) => generateSGTINS(payload),
		onSuccess: (data) => {
			if (mutationOptions.onSuccess) {
				mutationOptions.onSuccess(data);
			}
		},
		onError: (error) => {
			if (mutationOptions.onError) {
				mutationOptions.onError(error);
			}
		},
	});

	return {
		generateSGTIN: mutation.mutate,
		isLoading: mutation.isPending,
		...mutation,
	};
};

const useGetSSCCData = (params) => {
	return useQuery({
		queryKey: [ssccKey, params],
		queryFn: () => getSSCCData(params),
		keepPreviousData: true,
	});
};

const useGetSGTINData = (params) => {
	return useQuery({
		queryKey: [sgtinKey, params],
		queryFn: () => getSGTINSData(params),
		keepPreviousData: true,
		enabled: !!params?.currentPage, // Only run if we have params
	});
};

const useDownloadSgtinLabels = (mutationOptions = {}) => {
	const mutation = useMutation({
		mutationFn: ({ clientId, traceId }) => downloadSgtinLabels(clientId, traceId),
		onSuccess: (data) => {
			if (mutationOptions.onSuccess) {
				mutationOptions.onSuccess(data);
			}
		},
		onError: (error) => {
			if (mutationOptions.onError) {
				mutationOptions.onError(error);
			}
		},
	});

	return {
		downloadLabels: mutation.mutate,
		isLoading: mutation.isPending,
		data: mutation.data,
		...mutation,
	};
};

export { 
	useGenerateSSCC, 
	useGenerateSGTIN, 
	useGetSSCCData, 
	useGetSGTINData,
	useDownloadSgtinLabels,
};